import {
    UPDATE_WIZARD_BIRTHDATE,
    UPDATE_WIZARD_REFERENCE_AUTHORIZATION,
    UPDATE_LEGAL_GUARDIAN_VISIBILITY,
    UPDATE_WIZARD_SUB_STEP,
    UPDATE_WIZARD_TOGGLE,
    UPDATE_NUMBER_OF_OPTIONAL_DOCUMENTS,
} from '../../mutation-types';

const dateRegex = new RegExp('([0-2]?[0-9]|3[0-1])[.](0?[1-9]|1[0-2])[.][0-9]{4}');
const getAge = birthDate => Math.floor((new Date() - new Date(...birthDate.split('.').reverse()).getTime()) / 3.15576e+10);

export default {
    [UPDATE_WIZARD_TOGGLE](state, { key, value }) {
        state[key] = value;
    },
    [UPDATE_WIZARD_BIRTHDATE](state, { value }) {
        state.isMinor = (dateRegex.test(value) && getAge(value) < 18);
    },
    [UPDATE_WIZARD_REFERENCE_AUTHORIZATION](state, { value }) {
        state.parentalAuthorization = value === 'parents';
    },
    [UPDATE_LEGAL_GUARDIAN_VISIBILITY](state) {
        state.showLegalGuardian1 = state.isMinor || state.parentalAuthorization;
    },
    [UPDATE_WIZARD_SUB_STEP](state, { value }) {
        state.currentSubStep = value;
        state.furthestSubStep = Math.max(value, state.furthestSubStep);
    },
    [UPDATE_NUMBER_OF_OPTIONAL_DOCUMENTS](state, { value }) {
        state.numberOfOptionalDocuments = value;
    },
};
